<app-parker-registration-detail-parker-details [parker]="parkingSession.knownTag?.parker"
  [companyName]="parkingSession.knownTag?.parker?.company?.name" [knownTag]="parkingSession.knownTag"
  [unknowParkerTagFull]="parkingSession.unknownParkerTagCountryCode + ' ' + parkingSession.unknownParkerTagControlPlateNumber">
</app-parker-registration-detail-parker-details>
<hr>
<div class="form-row row">
  <div class="form-group col-md-6">
    <label class="control-label">{{'i18n.domain.parker-registration.fields.parkingDuration' | translate}}</label>
    <div>{{getParkingDuration()}}</div>
  </div>
  <div class="form-group col-md-6">
    <label class="control-label">{{'i18n.domain.parker-registration.fields.zone' | translate}}</label>
    <div>{{parkingSession.registeredZone.name}}</div>
  </div>
</div>
@if (parkingSession.subscription) {
  <div class="form-row row">
    <div class="form-group col-md-6 mb-0">
      <label class="control-label">{{'i18n.domain.parker-registration.fields.subscription' | translate}}</label>
      <div>{{parkingSession.subscription.name}}</div>
    </div>
    <div class="form-group col-md-6 mb-0">
      <label class="control-label">{{'i18n.domain.parker-registration.fields.subscription-type' | translate}}</label>
      <div>{{getSubscriptionType(parkingSession.subscription) | translate}}</div>
    </div>
  </div>
}
@if (!parkingSession.subscription) {
  <div class="form-row row">
    <div class="form-group col-md-6 mb-0">
      <label class="control-label">{{'i18n.domain.parker-registration.fields.subscription' | translate}}</label>
      <div>{{'i18n.domain.parker-registration.fields.no-subscription' | translate}}</div>
    </div>
  </div>
}
<hr>
<h5>{{'i18n.domain.parker-registration.dialog.entry' | translate}}</h5>
<div class="form-row row">
  <div class="form-group col-md-6">
    <label class="control-label">{{'i18n.domain.parker-registration.fields.registrationDateTime' | translate}}</label>
    <div>{{entry?.registrationDateTime?.toFormat('dd.MM.yyyy HH:mm:ss')}}</div>
  </div>
  <div class="form-group col-md-6">
    <label class="control-label">{{'i18n.domain.parker-registration.fields.type' | translate}}</label>
    <div>{{getRegistrationType(entry) | translate}}</div>
  </div>
</div>
@if (exit?.type === 1) {
  <div class="form-row row">
    <div class="form-group col-md-6 mb-0">
      <label class="control-label">{{'i18n.domain.parker-registration.fields.issuer' | translate}}</label>
      <div>{{getRegisteredByText(entry)}}</div>
    </div>
  </div>
}
@if (exit) {
  <h5 class="mt-3">{{'i18n.domain.parker-registration.dialog.exit' | translate}}</h5>
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label class="control-label">{{'i18n.domain.parker-registration.fields.registrationDateTime' | translate}}</label>
      <div>{{exit?.registrationDateTime?.toFormat('dd.MM.yyyy HH:mm:ss')}}</div>
    </div>
    <div class="form-group col-md-6">
      <label class="control-label">{{'i18n.domain.parker-registration.fields.type' | translate}}</label>
      <div>{{getRegistrationType(exit) | translate}}</div>
    </div>
  </div>
  @if (exit?.type === 1) {
    <div class="form-row row">
      <div class="form-group col-md-6 mb-0">
        <label class="control-label">{{'i18n.domain.parker-registration.fields.issuer' | translate}}</label>
        <div>{{getRegisteredByText(exit) | translate}}</div>
      </div>
    </div>
  }
}
@if (offenses && offenses.length > 0) {
  <hr>
  <ejs-tab>
    <e-tabitems>
      @for (offense of offenses; track offense) {
        <e-tabitem>
          <ng-template #headerTemplate>
            {{offense.registrationDateTime?.toFormat('dd.MM.yyyy HH:mm')}}
          </ng-template>
          <ng-template #content>
            <app-parker-registration-detail-offense [offense]="offense" [displayIssuerName]="true">
            </app-parker-registration-detail-offense>
          </ng-template>
        </e-tabitem>
      }
    </e-tabitems>
  </ejs-tab>
}
